export default function (state, getters, rootState, rootGetters) {
    const form = rootState.subsidies.item.form;
    let sum = 0;
    state.PaymentDetails.forEach(i => {
        sum += i.Spread;
    });
    return form.Sum - sum;
}
